import * as React from 'react'
import * as LabelPrimitive from '@radix-ui/react-label'
import { tv, VariantProps } from 'tailwind-variants'

import { cn } from '@cannect/lib/utils'

const labelVariants = tv({
  base: 'font-sans text-sm font-medium leading-none text-gray-900 peer-disabled:cursor-not-allowed peer-disabled:opacity-70'
})

const Label = React.forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> & VariantProps<typeof labelVariants>
>(({ className, ...props }, ref) => (
  <LabelPrimitive.Root ref={ref} className={cn(labelVariants(), className)} {...props} />
))
Label.displayName = LabelPrimitive.Root.displayName

export { Label }
